import React, { FC } from 'react';
import { BasketItem, BasketItemAttr, BasketItemSelectorTypes } from '../BasketMain/types';
import BasketItemBasicSelector from './BasketItemBasicSelector/BasketItemBasicSelector';
import BasketItemEnvelopesSelector from './BasketItemEnvelopesSelector/BasketItemEnvelopesSelector';
import BasketItemFrameSelector from './BasketItemFrameSelector/BasketItemFrameSelector';
import BasketItemQuantitySelector from './BasketItemQuantitySelector/BasketItemQuantitySelector';
import styles from './BasketItemSelectors.module.scss';

interface BasketItemSelectorsProps {
  onChangeSelector: (orderItemId: number, attr: BasketItemAttr) => void;
  orderItemId: number;
  appliedItemSelectors: any;
  soloSelector?: string;
  excludeSelector?: string[];
}

const BasketItemSelectors: FC<BasketItemSelectorsProps> = ({
  appliedItemSelectors,
  onChangeSelector,
  orderItemId,
  soloSelector,
  excludeSelector,
}) => {
  // let selectors = soloSelector
  //   ? appliedItemSelectors.filter((sel) => sel.typeName === soloSelector)
  //   : appliedItemSelectors;

  // selectors = excludeSelector
  //   ? selectors.filter((sel) => excludeSelector.indexOf(sel.typeName) !== -1)
  //   : appliedItemSelectors;

  // const appliedSelectors = ['FRAMES'];

  return (
    <div className={styles.selectors}>
      {appliedItemSelectors.map((selector: any) => {
        if (selector === 'FRAMES') {
          return (
            <BasketItemFrameSelector
              key={selector}
              onChangeSelector={() => {}}
              orderItemId={orderItemId}
              selector={selector}
            />
          );
        }
        if (selector === 'ENVELOPES') {
          return (
            <BasketItemEnvelopesSelector
              key={selector}
              onChangeSelector={() => {}}
              orderItemId={orderItemId}
              selector={selector}
            />
          );
        }
        return null;
        // if (!selector.editable) {
        //   return <BasketItemBasicSelector key={selector.typeName} name={selector.title} value={selector.value} />;
        // }
        // return <div>Placeholder</div>;
        // switch (selector.typeName) {
        //   case BasketItemSelectorTypes.quantity:
        //     return (
        //       <BasketItemQuantitySelector
        //         key={selector.typeName}
        //         onChangeSelector={onChangeSelector}
        //         orderItemId={orderItemId}
        //         selector={selector}
        //       />
        //     );
        //   case BasketItemSelectorTypes.frames:
        //     return (
        //       <BasketItemFrameSelector
        //         key={selector.typeName}
        //         onChangeSelector={onChangeSelector}
        //         orderItemId={orderItemId}
        //         selector={selector}
        //       />
        //     );

        //   default:
        //     return null;
        // }
      })}
    </div>
  );
};

export default BasketItemSelectors;
